import './CSS/AboutMePic.css';
function AboutMeShadow() {
    return (
        <div id="queenShadow"/>             
    );
  }
  
  export default AboutMeShadow;
  